<script setup lang="ts">
withDefaults(
  defineProps<{
    padding?: 'none' | 'sm' | 'md' | 'lg'
    raised?: boolean
    accent?: 'none' | 'primary' | 'accent'
    hover?: boolean
  }>(),
  { padding: 'md', raised: true, accent: 'none', hover: false }
)
</script>

<template>
  <div
    class="card"
    :class="[
      `card--padding-${padding}`,
      `card--accent-${accent}`,
      { 'card--raised': raised, 'card--hover': hover },
    ]"
  >
    <slot />
  </div>
</template>

<style scoped>
.card {
  position: relative;
  background-color: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  overflow: hidden;
  transition:
    transform 0.15s ease,
    box-shadow 0.15s ease,
    border-color 0.15s ease;
}

.card--raised {
  box-shadow:
    0 1px 2px rgb(0 0 0 / 0.05),
    0 4px 12px rgb(0 0 0 / 0.04);
}

.card--hover:hover,
a .card:hover,
.card:has(.card__hover-trigger:hover) {
  transform: translateY(-3px);
  box-shadow:
    0 1px 2px rgb(0 0 0 / 0.05),
    0 12px 24px rgb(0 0 0 / 0.08);
}

.card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 5px;
  background: transparent;
}

.card--accent-primary::before {
  background: linear-gradient(90deg, var(--color-primary-light), var(--color-primary));
}

.card--accent-primary {
  border-left: 4px solid var(--color-primary);
}

.card--accent-accent::before {
  background: linear-gradient(90deg, var(--color-accent-light), var(--color-accent));
}

.card--accent-accent {
  border-left: 4px solid var(--color-accent);
}

.card--padding-sm {
  padding: var(--space-3);
}
.card--padding-md {
  padding: var(--space-5);
}
.card--padding-lg {
  padding: var(--space-6);
}
</style>
